import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import { GlobalStateContext } from "../context/GlobalContextProvider"
import { apps } from "../data/apps"

export default function AppLines() {
  const state = React.useContext(GlobalStateContext)
  function currentLang() {
    return state ? state.lang : "en"
  }
  return (
    <Wrapper>
      <AppWrapper count={apps.length}>
        {apps.map((item, index) => (
          <Link to={item.link + "?l=" + currentLang()} key={index}>
            <Logo src={item.appIcon}></Logo>
          </Link>
        ))}
      </AppWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const AppWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.count}, 80px);
  flex-direction: column;
  gap: 20px;
  align-items: center;
`

const Logo = styled.img`
  width: 80px;
  margin: 0 auto;
`
